import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { getDomain } from './constants';
import store from "../store"; // Import the Redux store
import { showError } from "../store/errorSlice"; // Import the action
import { getCookie } from './utils';
// Create axios instance with default config
const axiosInstance: AxiosInstance = axios.create({
  baseURL: getDomain(),
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getCookie('Authorized');
    const userId = localStorage.getItem('userid');
    
    // Only set Content-Type to application/json if it's not FormData
    // FormData needs to set its own Content-Type with boundary
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    } else {
      // Remove Content-Type header for FormData - browser will set it with boundary
      delete config.headers['Content-Type'];
    }
    

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (userId) {
      config.headers['X-User-Id'] = userId;
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    // Handle specific error cases
    if (error.response) {
      switch (error.response.status) {
        case 401:
          const publicPaths = ['/', '/payments']; // Add your allowed paths here

          if(!publicPaths.includes(window.location.pathname)){
            store.dispatch(showError('Unauthorized'));
          }
          // window.location.href = '/error';
          break;
        case 500: {
          const beMessage = (error.response?.data as { message?: string } | undefined)?.message;
          store.dispatch(showError(beMessage || 'Something went wrong. Please try again later.'));
          break;
        }
      }
    }

    // Log all errors
    console.error('API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.message,
      data: error.response?.data
    });

    return Promise.reject(error);
  }
);

export default axiosInstance; 